import { Group } from '@mantine/core';

import { PublicationIdentifiers } from '@/module/Author/Publication/model/PublicationTypes';

import { ExternalSourceLink } from '@feature/utils';

interface IdentifiersLinksProps {
  identifiers: PublicationIdentifiers;
}

export function IdentifierLinks({ identifiers }: IdentifiersLinksProps) {
  return (
    <Group>
      {identifiers?.doi && (
        <ExternalSourceLink
          url={`https://dx.doi.org/${identifiers.doi}`}
          name={`https://dx.doi.org/${identifiers.doi}`}
        />
      )}
      {identifiers?.wosLink && (
        <ExternalSourceLink
          url={identifiers.wosLink}
          name="Link WoS"
        />
      )}
      {identifiers?.scopusLink && (
        <ExternalSourceLink
          url={identifiers.scopusLink}
          name="Link Scopus"
        />
      )}
    </Group>
  );
}
